import instanceService from './instance'

import { DEAL_SERVER_URL } from '../helpers/constants'

let instance = instanceService.instance(DEAL_SERVER_URL)

export const transactionsService = {
    getTransactionGroups,
    getTransactionPeriod,
    getTransactions,
    getLastTransaction,
    getLastTransactionBatch,
    createTransactionExternal,
    createTransactionBatch,
    revertTransaction,
    editTransaction,
    getPeriodsAnnuityDeal,
    payAnnuityPeriod,
    getCalcAnnuityDeal,
    closeAnnuityDeal
}

function getTransactionGroups(data) {
    const options = {
        method: 'POST',
        data: data,
        url: '/transactions/groups'
    }
    return instance(options)
}

function closeAnnuityDeal(data) {
    const options = {
        method: 'POST',
        data: data,
        url: '/annuity/close'
    }
    return instance(options)
}

function getCalcAnnuityDeal(data) {
    const options = {
        method: 'POST',
        data: data,
        url: '/annuity/calculate/closure'
    }
    return instance(options)
}

function getPeriodsAnnuityDeal(dealId) {
    const options = {
        method: 'GET',
        url: `/annuity/payments/${dealId}`
    }
    return instance(options)
}

function payAnnuityPeriod(data) {
    const options = {
        method: 'POST',
        data: data,
        url: `/annuity/pay`
    }
    return instance(options)
}

function getTransactions(data) {
    const options = {
        method: 'POST',
        data: data,
        url: '/transactions'
    }
    return instance(options)
}

function getTransactionPeriod(data) {
    const options = {
        method: 'POST',
        data: data,
        url: '/transactions/period'
    }
    return instance(options)
}

function createTransactionExternal(data) {
    const options = {
        method: 'POST',
        data: data,
        url: '/transactions/external'
    }
    return instance(options)
}

function createTransactionBatch(data) {
    const options = {
        method: 'POST',
        data: data,
        url: '/transactions/batch'
    }
    return instance(options)
}

function getLastTransaction(type) {
    const options = {
        method: 'GET',
        url: `/transactions/last/${type}`
    }
    return instance(options)
}

function getLastTransactionBatch(payload) {
    const options = {
        method: 'GET',
        url: `/transactions/batch/last/${payload.type}/${payload.cashBoxId}`
    }
    return instance(options)
}

function revertTransaction(id) {
    const options = {
        method: 'PUT',
        url: `/transactions/revert/${id}`
    }
    return instance(options)
}

function editTransaction(payload) {
    const options = {
        method: 'PUT',
        data: payload,
        url: `/transactions/${payload.id}`
    }
    return instance(options)
}
